//example
// export const ORG_CREATE = `/organization/create`;
// export const ORG_UPDATE = (id) => `/organization/update?id=${id}`;

//org menuitems
export const ORG_MENUITEMS_CREATE = `/api/menuitem`;
export const ORG_MENUITEMS_UPDATE = (id) => `/api/menuitem/${id}`;

//org menucategories
export const ORG_MENUCATEGORY_CREATE = `/api/menucategory`;

export const ORG_MENUCATEGORY_UPDATE = (id) => `/api/menucategory/${id}`;


//Update profile

export const ORG_PROFILE_UPDATE = (orgCode) => `/api/org/${orgCode}`;


